<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xs(:title="$t('sec2')" tag="h2")
        p.u-mb-mi {{$t('sec2Desc')}}
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec5')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec5Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec6')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec6Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Odoo",
    "pageDesc":"We provide Odoo customization and development services for businesses of all sizes and across industries.",
    "mantra":"Manage your business |with Odoo solutions.",
    "mantraDesc":"Odoo is a smart management solution that would help you scale your business operations and streamline your activities in different departments including manufacturing, finance and accounting, purchase, sales, warehouse, and HR among others.",
    "sec1":"Why convert to Odoo?",
    "sec1Items":{
      "1":{
        "title":"Wide popularity ",
        "desc":"Odoo is used by many businesses around the world from different sizes and types which males suitable forever business case."
      },
      "2":{
        "title":"Thousands of modules",
        "desc":"With many ready-to-use modules, Odoo is highly customizable for your business needs."
      },
      "3":{
        "title":"Cloud Based",
        "desc":"Manage your data business anywhere around the globe with a solution that can be easily accessed from any device."
      },
      "4":{
        "title":"Comprehensive system",
        "desc":"Centralize your business and align your department's work using a system that works on one database."
      }
    },
    "sec2":"Experience Odoo customizations.",
    "sec2Desc":"We provide customization for different services and industries based on the gap analysis and business requirements. ",
    "sec2Items":{
      "1":{
        "title":"Odoo for agencies",
        "desc":"Organize the work inside your agency. Manage your human resources, financial reporting and day-to-day operations."
      },
      "2":{
        "title":"Odoo for manufacturing",
        "desc":"Automate your business manufacturing processes and run your factory in a smart manner whether you are working in IT manufacturing, wood, plastic or other."
      },
      "3":{
        "title":"Odoo for retail",
        "desc":"Create better customer experiences through a point of sale system that facilitates your operation in stores."
      },
      "4":{
        "title":"Odoo for warehouse and inventory",
        "desc":"Manage your inventory in a smart manner  and customize your operations process."
      },
      "5":{
        "title":"Odoo for sales",
        "desc":"Reduce your churn rate and optimize your sales funnel for better conversion rates through process automation."
      },
      "6":{
        "title":"Odoo for education",
        "desc":"Whether a school or a training center, Odoo lets you manage your operations from teachers to students and lecturers. "
      }
    },
    "sec3":"Various integrations for extra options.",
    "sec3Items":{
      "1":{
        "title":"Payment gateways",
        "desc":"Extend your system functionalities through payment gateways integration including Paypal, square and more."
      },
      "2":{
        "title":"Shipping integrations",
        "desc":"Add the shipping and delivery features to your system and track orders in a more accurate manner."
      },
      "3":{
        "title":"Accounting integrations",
        "desc":"Have a system that integrates seamlessly with your current accounting systems and sync your data across the organization."
      },
      "4":{
        "title":"Call centre integrations",
        "desc":"Cnertrzlize the communication with your customers and generate reports that helps you in building long term relationships with your clients."
      }
    },
    "sec4":"Consultations that help you thrive.",
    "sec4Items":{
      "1":{
        "title":"Functional consulting",
        "desc":"Making sure your system matches the business needs and the planned features."
      },
      "2":{
        "title":"Solution reinvention.",
        "desc":"Whether you would like to revamp your old version or continue with a project that you started already, we help start from where you left according to your business needs."
      },
      "3":{
        "title":"Technical consulting",
        "desc":"Examining your current system, understanding your business needs then planning and coding the necessary fixes for your system"
      }
    },
    "sec5":"Services for every need.",
    "sec5Items":{
      "1":{
        "title":"Implementation",
        "desc":"Developing custom Odoo solutions with a user-friendly interface and using the latest technologies to boost your business performance."
      },
      "2":{
        "title":"Support and maintenance",
        "desc":"Starting from bug fixes, to customization and documentation, we help you across the different aspects of the system problems."
      },
      "3":{
        "title":"Store development",
        "desc":"Build up your online presence through Odoo store development that helps you drive higher revenue rates."
      },
      "4":{
        "title":"Module development",
        "desc":"Creating the features you need and doesn’t exist in Odoo system and matching it with your industry specifications."
      },
      "5":{
        "title":"Theme development",
        "desc":"Building themes that support both of your backend and frontend and takes into account the user experience."
      }
    },
    "sec6":"Making you the Odoo you need.",
    "sec6Items":{
      "1":{
        "title":"Requirement analysis",
        "desc":"Outlining the project scope and the needed features that would support your business operations."
      },
      "2":{
        "title":"Customization and development",
        "desc":"From the design customization to the development process, we code the Odoo solution with the necessary modules. "
      },
      "3":{
        "title":"Data migration",
        "desc":"Transferring your old data whether from old Odoo versions, excel files or software to the new developed solution. "
      },
      "4":{
        "title":"Testing",
        "desc":"Making sure that solution is stable and ready for launch with no errors or missing features."
      }
    },
    "cta":"Custom your Odoo <br> solution"
  },
  "ar": {
    "pageTitle":"أودو",
    "pageDesc":"نوفر خدمات التخصيص والبرمجة الخاصة بأودو للشركات من جميع الأحجام ومختلف الصناعات لتلبية جميع احتياجات عملك.",
    "mantra":"حلول أودو لتنظيم |إدارة أعمالك.",
    "mantraDesc":"أودو هو حل إداري ذكي يساعدك على تنظيم وإدارة أعمالك وكذلك يوسع من نطاق عملياتك التجارية ويسهل أداء أنشطتك في مختلف الإدارات بما في ذلك التصنيع والتمويل والمحاسبة والشراء والمبيعات والمستودعات والموارد البشرية ...وغيرها.",
    "sec1":"لماذا عليك التفكير في أودو؟",
    "sec1Items":{
      "1":{
        "title":"شعبية واسعة",
        "desc":"يستخدم أودو من قبل العديد من الشركات في جميع أنحاء العالم من مختلف الأحجام والأنواع مما يعني أنها مناسبة لجميع حالات الأعمال التجارية المختلفة."
      },
      "2":{
        "title":"آلاف من الوحدات",
        "desc":"مع آلاف من الوحدات الجاهزة للاستخدام، يعد أودو قابل للتخصيص بشكل مناسب من أجل احتياجات عملك المتنوعة."
      },
      "3":{
        "title":"قائم على السحابة",
        "desc":"يمكنك إدارة أعمالك والوصول إلى بياناتك في أي مكان في العالم بسرعة عبر أي جهاز."
      },
      "4":{
        "title":"نظام شامل",
        "desc":"اعمل على تمركز أعمالك ووائم بين الأقسام المختلفة لعملك من خلال نظام على قاعدة بيانات واحدة."
      }
    },
    "sec2":"تجربة أودو المخصصة لاحتياجات عملك.",
    "sec2Desc":"نوفر التخصيصات للخدمات والصناعات المختلفة القائمة على متطلبات العمل وكذلك لسد الفجوة التي تؤثر على عملك.",
    "sec2Items":{
      "1":{
        "title":"أودو للوكالات",
        "desc":"نظم العمل داخل وكالتك من خلال إدارة الموارد البشرية بشكل دقيق وكذلك لإعداد التقارير المالية والعمليات اليومية. "
      },
      "2":{
        "title":"أودو للتصنيع",
        "desc":"قم بأتمتة عمليات التصنيع الخاصة بعملك وأدر مصنعك بطريقة أكثر ذكاءً، سواء كنت تعمل في مجال تكنولوجيا المعلومات أو الخشب أو البلاستيك أو غير ذلك."
      },
      "3":{
        "title":"أودو للبيع بالتجزئة",
        "desc":"وفر تجارب أفضل لعملائك من خلال نظام نقاط البيع الذي يسهل عليك أداء عملك في المتجر."
      },
      "4":{
        "title":"أودو للمستودعات والمخازن",
        "desc":"يمكنك إدارة المخزون الخاص بك بطريقة ذكية من خلال تخصيص عملياتك بما يتناسب معك."
      },
      "5":{
        "title":"أودو للمبيعات",
        "desc":"قلل من الوقت الضائع والمستنزف في المبيعات وحسن من مسار مبيعاتك من خلال أتمتة عملياتك التي تزيد من معدلات التحويل لديك."
      },
      "6":{
        "title":"أودو للتعليم",
        "desc":"سواء كنت مدرسة أو مركز تدريب، فإن أدود يتيح لك إدارة عملياتك بداية من المعلمين والمحاضرين إلى الطلاب."
      }
    },
    "sec3":"تكاملات مختلفة للحصول على خيارات إضافية.",
    "sec3Items":{
      "1":{
        "title":"بوابات الدفع",
        "desc":"يمكنك زيادة وظائف النظام الخاص بك من خلال تكامل بوابات الدفع بما في ذلك باي بال ...وغيرها"
      },
      "2":{
        "title":"تكامل الشحن",
        "desc":"أضف مميزات الشحن والتسليم إلى النظام الخاص بك وتتبع الطلبات بطريقة أكثر دقة وفاعلية."
      },
      "3":{
        "title":"تكامل المحاسبة",
        "desc":"احصل على نظام يتكامل بسلاسة مع أنظمة المحاسبة الحالية التي تمتلكها وقم بالمزامنة بين البيانات الخاصة بك في جميع أنحاء عملك."
      },
      "4":{
        "title":"تكامل مركز الاتصال",
        "desc":"اعمل على مركزية التواصل وقم بإنشاء تقارير تساعدك على بناء علاقات طويلة الأمد معهم."
      }
    },
    "sec4":"استشارات تساعدك على النمو.",
    "sec4Items":{
      "1":{
        "title":"الاستشارات الوظيفية",
        "desc":"تأكد من مطابقة النظام لاحتياجات العمل والمميزات المخطط لها."
      },
      "2":{
        "title":"إعادة اختراع الحل.",
        "desc":"سواء كنت ترغب في تجديد نسختك القديمة أو متابعة مشروع قد بدأت فيه بالفعل، سوف نساعدك على العمل من حيث انتهيت وفقًا لاحتياجات عملك."
      },
      "3":{
        "title":"الاستشارات التقنية",
        "desc":"افحص نظامك الحالي وافهم احتياجات عملك ثم خطط للكود المناسب من أجل الإصلاحات الضرورية لنظامك."
      }
    },
    "sec5":"خدمات لكل متطلبات عملك.",
    "sec5Items":{
      "1":{
        "title":"التنفيذ",
        "desc":"طور حلول أودو المخصصة مع واجهة سهلة الاستخدام عن طريق أحدث التقنيات من أجل تعزيز أداء عملك."
      },
      "2":{
        "title":"الدعم والصيانة",
        "desc":"بداية من إصلاحات الأخطاء والمشكلات إلى التخصيص والتوثيق، نساعدك على حل المشكلات المختلفة الموجودة بالنظام."
      },
      "3":{
        "title":"تطوير المتجر",
        "desc":"زود من تواجدك عبر الإنترنت من خلال تطوير متاجر أودو الذي يساعدك على زيادة معدلات الإيرادات."
      },
      "4":{
        "title":"تطوير الوحدة",
        "desc":"نفذ المميزات التي تحتاجها والغير موجودة في نظام أودو وقم بمطابقتها مع مواصفات الصناعة واحتياجات عملك."
      },
      "5":{
        "title":"تطوير القالب",
        "desc":"وفر القالب الذي يدعم كل من الواجهة الخلفية والواجهة الأمامية وفي نفس الوقت تهتم بتجربة المستخدم."
      }
    },
    "sec6":"نوفر لك نظام أودو الذي تحتاجه.",
    "sec6Items":{
      "1":{
        "title":"تحليل المتطلبات",
        "desc":"نفهم متطلبات واحتياجات عملك من أجل تحديد نطاق المشروع والمميزات اللازمة التي تدعم عمليات عملك."
      },
      "2":{
        "title":"التخصيص والبرمجة",
        "desc":"بداية من التصميم إلى التخصيص، نقوم ببرمجة حلول أودو بالإضافة إلى الوحدات الضرورية التي يحتاج إليها عملك."
      },
      "3":{
        "title":"نقل البيانات",
        "desc":"نساعدك على نقل بياناتك القديمة بدون أي مشكلات أو مخاوف سواء من إصدارات أودو القديمة أو ملفات الإكسل إلى االحل الجديد المطور."
      },
      "4":{
        "title":"اختبار الحل",
        "desc":"نتأكد من أن الحل مستقر وليس به أخطاء وجاهز للعمل ولا يوجد أي مميزات يحتاجها عملك غير موجودة."
      }
    },
    "cta":"خصص حلول أودو <br> حسب احتياجات عملك"
  }
}
</i18n>
